import React from "react";
import { useSpring, animated as A } from "react-spring";
import { colors } from "../../../shared/constants";
export var AnimatedCheck = function AnimatedCheck(_ref) {
  var e = _ref.isValid;
  var t = useSpring({
    x: e ? 0 : 100
  });
  return React.createElement(A.svg, {
    viewBox: "0 0 32 24",
    "data-testid": "valid-checkmark",
    fill: "none",
    strokeDasharray: 100,
    strokeDashoffset: t.x,
    strokeWidth: 5
  }, React.createElement("polyline", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: colors.green4,
    points: "4, 12 11.876924, 20 27.630768, 4"
  }));
};
export default AnimatedCheck;